import { css } from "@emotion/react"
import { Icon, Paragraph } from "@ncs/web-legos/components"
import { useState, ReactNode } from "react"

type AccordionProps = {
	title: string
	children: ReactNode
}

export const Accordion = ({ children, title }: AccordionProps) => {
	const [open, setOpen] = useState<boolean>(false)
	const contentId = title

	return (
		<>
			<button
				css={accordionButton}
				onClick={() => setOpen(!open)}
				aria-expanded={open}
				aria-controls={contentId}
				id={contentId}
			>
				<Paragraph bold>{title}</Paragraph>
				{open ?
					<Icon icon="chevron-up" aria-hidden="true" customColor="#00050A" />
				:	<Icon icon="chevron-down" aria-hidden="true" customColor="#00050A" />}
			</button>

			<div id={contentId} role="region" aria-labelledby={contentId} hidden={!open}>
				{children}
			</div>
		</>
	)
}

const accordionButton = css`
	display: flex;
	justify-content: space-between;
	width: 100%;
	background: none;
	border: none;
	align-items: center;
	cursor: pointer;
	color: #00050a;
	font-size: 1rem;
	text-align: left;
	padding: 1rem 0;
`
